import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-statistic",
  "use": "icon-statistic-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-statistic\"><path d=\"M931.84 985.6H81.92c-14.336 0-25.6-11.264-25.6-25.6V87.04c0-14.336 11.264-25.6 25.6-25.6s25.6 11.264 25.6 25.6v847.36h824.32c14.336 0 25.6 11.264 25.6 25.6s-11.264 25.6-25.6 25.6zM286.72 865.28c-14.336 0-25.6-11.264-25.6-25.6v-261.12c0-14.336 11.264-25.6 25.6-25.6s25.6 11.264 25.6 25.6v261.12c0 14.336-11.264 25.6-25.6 25.6zM440.32 865.28c-14.336 0-25.6-11.264-25.6-25.6V322.56c0-14.336 11.264-25.6 25.6-25.6s25.6 11.264 25.6 25.6v517.12c0 14.336-11.264 25.6-25.6 25.6zM599.04 865.28c-14.336 0-25.6-11.264-25.6-25.6V445.44c0-14.336 11.264-25.6 25.6-25.6s25.6 11.264 25.6 25.6v394.24c0 14.336-11.264 25.6-25.6 25.6zM757.76 865.28c-14.336 0-25.6-11.264-25.6-25.6V199.68c0-14.336 11.264-25.6 25.6-25.6s25.6 11.264 25.6 25.6v640c0 14.336-11.264 25.6-25.6 25.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/statistic.svg
// module id = afyG
// module chunks = 132